import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/projects.css';
import { FaExternalLinkSquareAlt, FaBars, FaArrowRight} from 'react-icons/fa';


const Project = () => {
    const [open, setOpen] = useState(false);
    return (
         <div className="">
            <nav>
                <div className="logo">fm</div>
                <ul className="nav-links" style={{ transform: open ? "translateX(0px)" : "" }}>
                    <li><Link className="nav-item" to="/">About</Link></li>
                    <li><Link className="nav-item" to="/" >Services</Link></li>
                    <li><Link className="nav-item" to="/projects">Projects</Link></li>
                    <li><Link className="nav-item" to="/">Skills</Link></li>
                    <li><Link className="nav-item" to='/' >Mentors</Link></li>
                    <li><Link className="nav-item" to="/blog">Blog</Link></li>
                    <li><Link className="nav-item" to="/contact">Contact</Link></li>
                </ul>
                <FaBars onClick={() => setOpen(!open)} className="fa-bars" color="#5cb85c" />
            </nav>
        <section>
            <div className='container' id="container-projects">
                <div id='the-project'>
                    <h1 className="display-3 font-800 text-left pb-4">Here are some of the complete website projects I have worked on both,
                        individual and commercial </h1>
                </div>   
                <div className="website-one">
                    <div className="left">
                        <div className="left-green"></div>
                    </div>
                    <div className="right">
                        <div className="float-right" id="float-right">
                            <h5>Ketech Geo IT</h5>
                            <h5>website</h5>
                        </div>
                        <div className="float-left" id="float-left">
                            <p className="text-muted lead mt-0">
                                A professional website for ketech, A company providing  Geospatial(GIS and RS) and  software developmemt consultancy.
                            </p>
                        </div>
                        <div className="float-right" id="float-right">
                            <h5>Vanilla JS| GitHub| HTML5| Bootstrap| Firebase</h5><br/>
                                <a href=""><FaExternalLinkSquareAlt size="2em" color="#5cb85c" /></a>
                        </div>
                    </div>    
                </div>
                <div className="website-one">
                    <div className="left-two">
                        <div id="float-right2">
                            <h5>Delani Studios</h5><br />
                            <h5>website</h5>
                        </div>
                        <div id="float-left2">
                             <p  className="text-muted lead mt-0">
                                A fully responsive free website template for download.
                            </p>
                        </div>
                        <div id="float-right2">
                            <h5>HTML5| JavaScript| Github| Bootstrap</h5>
                        </div>
                        <div id="float-right2">
                                <a href=""><FaExternalLinkSquareAlt size="2em" color="#5cb85c" /></a>
                        </div>
                    </div>
                    <div className="right-two">
                            <div className="left-green"></div>
                    </div>
                </div>
                <div className="website-one" id="website-one">
                    <div className="left1">
                            <div className="left-green"></div>
                    </div>
                    <div className="right">
                        <div className="float-right" id="float-right">
                            <h5>Zawadi Stores Kenya</h5><br />
                            <h5>website</h5>
                        </div>
                        <div className="float-left" id="float-left">
                            <p  className="text-muted lead mt-0">
                                     Web application for an online clothes and jewellery shop
                           </p>
                        </div>
                        <div className="float-right" id="float-right">
                            <h5>Heroku| Netlify| Nodejs| Reactjs|Bootstrap|mongodb </h5><br />
                                <a href=""><FaExternalLinkSquareAlt size="2em" color="#5cb85c"/></a>
                        </div>  
                    </div>
                </div>
            </div>
        </section>
        <section>
          <div className="container">
                <div id='the-projects2'>
                    <h1 className="display-3 font-800 text-left pb-4">Here are other notable mini projects</h1>
                </div> 
                <div className="row" id="all">
                        <a href="" className="col-sm text-muted lead mt-0" id="hover-effect"
                        data-text="Json web-token Mini-Application">
                    </a>
                    <a href="" className="col-sm text-muted lead mt-0" id="hover-effect"
                        data-text="Akan Naming System calculator ">
                    </a>
                    <a href="" className="col-sm text-muted lead mt-0" id="hover-effect"
                        data-text="Pizza Online Shop application">
                    </a>
                    <a href="" className="col-sm text-muted lead mt-0"  id="hover-effect"
                        data-text="Kenya 2019 National Census webmap">
                    </a>
                </div>
          </div>
        </section>
        <section>
            <div className="bt-container">
                <div className="green-shadow">
                    <h1 id="h1-bt">Get in touch</h1>
                    <div className='row' id="row-bt">
                        <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">
                                <Link className="bt_link" to="/contact">Reach out to me today</Link></button>
                            <div id="gif">
                                    <img src="./images/gif/giphy.gif" width="150" height="150" />
                            </div>
                        </div>
                        <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">Lets build awesome projects together</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div className="footer-section">
                <div className='footer-row'>
                    <div className="row">
                        <div className="col-sm" id="footer-col-sm">
                            <h4>My main goal</h4>
                            <li><a className="">
                                My main goal is to Intergrate <br /> existing GIS capabilities to <br />applications and solutions in<br /> various companies</a>
                            </li>
                        </div>
                        <div className="col-sm" id="footer-col-sm">
                            <h4>Links</h4>
                            <ul className="list-unstyled">
                                <li> <FaArrowRight /><a href="#about" className="">About</a></li>
                                <li> <FaArrowRight /><a href="#resume" className="">Resume</a></li>
                                <li> <FaArrowRight /><a href="#service" className="">Services</a></li>
                                <li> <FaArrowRight /><a href="#skills" className="">Skills</a></li>
                                <li> <FaArrowRight /><a href="#projects" className="">Projects</a></li>
                                <li> <FaArrowRight /><a href="#mentor" className="">Mentors</a></li>
                                <li> <FaArrowRight /><a href="#contacts" className="">Contacts</a></li>
                                <li> <FaArrowRight /><a href="#blog" className="">Blog</a></li>
                            </ul>
                        </div>
                         <div className="col-sm" id="footer-col-sm">
                            <h4 className="">Skills</h4>
                            <ul className="list-unstyled">
                                <li><FaArrowRight /><a href="#" className="">ReactJS</a></li>
                                <li><FaArrowRight /><a href="#" className="">NodeJS</a></li>
                                <li><FaArrowRight /><a href="#" className="">Django</a></li>
                                <li><FaArrowRight /><a href="#" className="">Web Development</a></li>
                                <li><FaArrowRight /><a href="#" className="">GIS analysis</a></li>
                                <li><FaArrowRight /><a href="#" className="">Python</a></li>
                                <li><FaArrowRight /><a href="#" className="">Remote Sensing</a></li>
                                <li><FaArrowRight /><a href="#" className="">Postgresql</a></li>
                            </ul>
                        </div>
                        <div className="col-sm" id="footer-col-sm">
                            <h4>Social platforms</h4>
                            <li><a>You can also find me on these social media platforms</a></li>
                            <ul className="list-unstyled" id="list-one">
                                <li id="icons1"><a href="https://www.linkedin.com/in/faith-muchembi-71b53910b" target="_blank"><span className="fa fa-linkedin" id="the-fa"></span></a></li>
                                <li id="icons2"><a href="https://github.com/fmuchembi" target="_blank"><span className="fa fa-github" id="the-fa1" ></span></a></li>
                                <li id="icons3"><a href="https://web.facebook.com/fmuchembi" target="_blank"><span className="fa fa-facebook" id="the-fa2"></span></a></li>
                                <li id="icons5"><a href="https://twitter.com/muchembif" target="_blank"><span className="fa fa-twitter" id="the-fa4"></span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="footer-section-2">
            <div className='footer-row2'>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>Copyright &copy; <script>document.write(new Date().getFullYear());</script> Designed and built by Faith Muchembi</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
    
    );
}



export default Project;